import React from 'react';
import '../styles/components/ExplanationField.scss';

interface ExplanationFieldProps {
    children: React.ReactNode;
}

const ExplanationField: React.FC<ExplanationFieldProps> = ({ children }) => {
    return <div className="explanation-field">{children}</div>;
};

export default ExplanationField;
